import * as React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import type { InjectedFormProps } from 'redux-form';
import { Field } from 'redux-form';

import Dropdown from 'af-fields/Dropdown';
import Input from 'af-fields/Input';

import type { ShiftSettingsFM } from '../formModel';

interface OwnProps {
	onSubmit: (form: ShiftSettingsFM) => Promise<void>;
}

type Props = OwnProps & InjectedFormProps<ShiftSettingsFM>;

interface TimeMinuteOption {
	name: string;
	value: number;
}

const minuteOptions: TimeMinuteOption[] = [
	{ name: '1 hour', value: 60 * 1 },
	...Array.from({ length: 11 }, (_, i) => i + 2).map((_h) => ({ name: `${_h} hours`, value: 60 * _h })),
];

const ShiftSettingsForm: React.FC<Props> = (props) => {
	const { onSubmit, handleSubmit } = props;

	return (
		<Form className="update-workdays" onSubmit={handleSubmit(onSubmit)}>
			<Row>
				<Col sm={8}>
					<Field
						component={Dropdown}
						fixed={true}
						id={'timeBetweenShifts'}
						isStandalone={true}
						label={'Select time between shifts'}
						labelKey="name"
						name={'timeBetweenShifts'}
						options={minuteOptions}
						valueKey="value"
						withCaret={true}
					/>
				</Col>
			</Row>
			<Row className="row--padded">
				<Col sm={8}>
					<Field
						allowNegative={false}
						component={Input}
						fixed={true}
						isStandalone={true}
						isZeroIfEmpty={true}
						label={<span>Enter maximum shift duration before the <b>first break</b> (hours)</span>}
						labelKey="name"
						name="maximumShiftDurationBeforeBreak1"
						type="number"
						valueKey="value"
						withCaret={true}
					/>
				</Col>
			</Row>
			<Row className="row--padded">
				<Col sm={8}>
					<Field
						allowNegative={false}
						component={Input}
						fixed={true}
						isStandalone={true}
						isZeroIfEmpty={true}
						label={<span>Enter maximum shift duration before the <b>second break</b> (hours)</span>}
						labelKey="name"
						name="maximumShiftDurationBeforeBreak2"
						type="number"
						valueKey="value"
						withCaret={true}
					/>
				</Col>
			</Row>
			<Row className="row--padded">
				<Col sm={8}>
					<Field
						allowNegative={false}
						component={Input}
						fixed={true}
						isStandalone={true}
						isZeroIfEmpty={true}
						label="Enter minimum break duration (minutes)"
						labelKey="name"
						name="minimumBreakDuration"
						type="number"
						valueKey="value"
						withCaret={true}
					/>
				</Col>
			</Row>
		</Form>
	);
};

export default React.memo(ShiftSettingsForm);
